import {HostBinding, ElementRef,QueryList,ViewChild,ViewChildren,Component, OnInit, OnChanges, OnDestroy ,SimpleChanges, AfterViewInit,ViewEncapsulation, Input, Output, EventEmitter} from '@angular/core';

import {Subscription} from 'rxjs'

declare var $ : any;

import {SectionI} from '../types';

import {BoxComponent} from '../boxes/boxes.component';

import {MessageService} from '../message.service';

import { Router,ActivatedRoute } from '@angular/router';


@Component({
  selector: 'sectionp',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.css'],
  encapsulation:ViewEncapsulation.None,

})

export class SectionComponent  implements OnInit,OnChanges,OnDestroy,AfterViewInit{

  navSettingIndex:number;
  navSettingStyle:any;
  msgSubscription:Subscription;

  sectionSetting:boolean=false

  @HostBinding('style.width') public width: string = '100%';


   @Input() element:any;

   @Input() pos:number;

   @Input() navigation:any;

   @Output() sectionAct = new EventEmitter();

   @Output() deleteIndex = new EventEmitter();

   @Output() sectionPopup = new EventEmitter();

    @Output() deleteBox = new EventEmitter();

   @ViewChild('set2', {static: false}) set2!: ElementRef;

   show_setting:boolean=false;


   @ViewChildren(BoxComponent) boxes !: QueryList<BoxComponent>;





  constructor(private msg:MessageService ,private  _router: Router){




    // this.show_setting  = this._router.url.includes('/template');

    this.show_setting  = this._router.url.indexOf('/template')>=0?true:false;

    this.msgSubscription=  this.msg.getMessage().subscribe( (e) =>{

      if(e!=undefined && e.text.action=='sendNavSettings'){

        if(this.element.type == e.text.type){

           this.element.setting.tittleCss=e.text.records.setting.tittleCss
           this.element.setting.subtittleCss=e.text.records.setting.subtittleCss
           this.element.setting.contentCss=e.text.records.setting.contentCss
           this.element.setting.readmoreCss=e.text.records.setting.readmoreCss


           this.sectionAct.emit({'element':this.element,'pos':this.pos,'action':'update_section'});


        }
      }

    })

  }

  section_order(order:string,cindex:number,nindex:number){



    this.sectionAct.emit({'move':order,'pos':cindex,'npos':nindex,'action':'order'});



  }

  boxEvent(evt:any){



    if(evt.type=='swap'){



        this.sectionAct.emit({'evt':evt,'action':'swap_record'});


    }else{

        this.sectionAct.emit({'evt':evt,'action':'insert_record'});



    }




  }



  dragInner(ev:any,element:any,ind:number){



    ev.dataTransfer.setData("text", JSON.stringify({'element':element,'action':'swap','epos':ind,'apos':this.pos,'type':element.type}) );


  }




  set_col(col:number){



   this.element.layout =col;

   for(let i=this.element.elements.length;i< col ;i++){



    this.element.elements.push({'navObject':{}})

   }


   this.sectionAct.emit({'element':this.element,'pos':this.pos,'action':'set_col'});


  }


  ngOnInit(){


  }

  ngOnChanges(ch:SimpleChanges){

  }

  ngAfterViewInit(){


  }

  ngOnDestroy(){


  }

  delete(index){

    this.deleteIndex.emit(index)
  }





  sectionConfig(evt,index){


    this.sectionPopup.emit({'evt':evt,'s_index':index});

  }

  sectionSettingRow(){

      if(this.sectionSetting==false){
        this.sectionSetting=true
      }else{
        this.sectionSetting=false
      }
  }




  deletedBox(index){
    this.deleteBox.emit(index)
  }






}
